export const paymentMethodFormTheme = {
  defaultIcon: {
    base: {
      bg: 'palette.transparent',
      borderRadius: '8px',
    },
    selected: {
      bg: 'palette.tertiary.20',
      borderRadius: '8px',
    },
  },
  methodCode: 'palette.tertiary.95',
  title: 'palette.tertiary.95',
};
